// 加解密函数集合
const RSAKey = require('js-jsbn/dist/rsa')

module.exports = function () {
  return {
    $get: [
      function () {
        const crypt = {
          /**
           * RSA加密
           * @param {string} content 内容
           * @param {hex} modulus 模数
           * @param {int} exponent 指数
          */
          RSAEncrypt(content, modulus, exponent) {
            const publicKey = new RSAKey()
            publicKey.setPublic(modulus, exponent)
            return publicKey.encrypt(content)
          }
        }
        return crypt
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/crypt.js